<template>
  <div>
    <div
      v-if="computedReportCard"
      class="main-content-container container-fluid px-4"
    >
      <!-- page header -->
      <div class="d-flex page-header row no-gutters py-4">
        <div class="col-12 col-md-8 mb-sm-0 mb-3 text-center text-sm-left">
          <span class="text-uppercase page-subtitle">Mes demandes</span>
          <h3 class="page-title">{{ title }}</h3>
        </div>
        <div class="col-12 col-md-4 pt-md-3">
          <div class="back-next-btn float-left float-sm-right">
            <button class="back-btn-submit" @click="back()">
              <i class="fa fa-arrow-left" aria-hidden="true"></i>
              {{ $t("global.return") }}
            </button>
            <button
              v-if="!computedReportCard.userName"
              class="next-btn-submit"
              @click="save()"
            >
              {{ $t("dailyReport.confirmBtn") }}
              <i class="fa fa-arrow-right" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div>
            <div class="body">
              <div class="row px-2">
                <div class="col-sm-8 col-md-12 col-lg-12 col-xl-8">
                  <div class="row">
                       <div class="col-md-6 col-xl-6">
            <div style="height: 150px" class="card card-custom mb-2 mb-md-4 mt-2 mt-md-3">
              <div class="card-body">
                <div class="d-flex flex-row align-items-center">
                  <div class="w-40 p-3 calander-div">
                    <img src="@/assets/images/calander.svg"  />
                  </div>
                  <div
                    class="w-60 font-weight-bold pt-5 pl-5 pl-sm-3 pl-lg-5 pl-xl-3 text-center date-time-div mb-md-4"
                  >
                    <p>{{ dateOfReport }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
                  
              <div class="col-md-6 col-xl-6">
            <div
              class="card card-custom mb-2 mb-md-4 mt-3"
              style="height: 150px"
            >
              <div class="card-body">
                <div class="d-flex flex-row align-items-center">
                  <div class="w-40 p-3 clock-div mt-3">
                    <img src="@/assets/images/clock-regular.svg" />
                  </div>
                  <div
                    class="w-60 font-weight-bold pt-5 pl-5 pl-sm-3 pl-lg-5 pl-xl-3 text-center date-time-div ml-md-4"
                  >
                    <p class="text-center">{{ $t("dailyReport.totalTime") }}</p>
                    <span class="text-center"> {{ computedReportCard.totalTime }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
         
                 
                    <div
                      class="col-md-6 col-xl-6"
                      v-for="(task, index) in computedReportCard.tasks"
                      :key="index"
                    >
                      <div
                        v-if="computedReportCard.totalTime != '0h 0min'"
                        class="card mb-2 mb-md-4 mt-3"
                      >
                        <div class="card body text-center py-3">
                          <span class="duration">
                            {{ task.startHour.hour }}:{{
                              task.startHour.mint
                            }}
                            - {{ task.endHour.hour }}:{{
                              task.endHour.mint
                            }}</span
                          >
                          <span class="text">
                            {{ task.title }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 col-md-12 col-lg-12 col-xl-4">
                  <div
                    class="card card-custom mb-2 mb-md-4 mt-2 mt-md-3"
                    v-if="computedReportCard.userName"
                  >
                    <div class="card-body">
                      <div class="d-flex flex-row align-items-center">
                        <div class="w-40 p-3 submission-div">
                          <img src="@/assets/images/maps-and-flags.svg" />
                        </div>
                        <div
                          class="w-60 font-weight-bold pt-4 pl-5 pl-sm-3 pl-lg-5 pl-xl-3 text-center date-time-div"
                        >
                          <p>{{ dateOfSubmission }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <dailyReport></dailyReport>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import dailyReport from '../../components/shared/dailyReport.vue';

export default {
  components: {
    dailyReport,
  },
  mounted(){
      
      this.reportCard=this.$store.state.dailyReport.reportCard
  },
  data(){
    return {
      reportCard : {}
    }
  },
  computed: {
    computedReportCard() {
      return this.$store.state.dailyReport.reportCard;
    },

    dateOfReport() {
      
      return moment(this.$store.state.dailyReport.dateOfReport).format('Do MMMM YYYY');
    },

    dateOfSubmission() {
      return `${moment(this.computedReportCard.dateOfSubmission).format('Do MMMM YYYY')} at ${moment(this.computedReportCard.dateOfSubmission).format('HH:mm')}`;
    },

    title() {
      return this.computedReportCard.userName
        ? `${this.computedReportCard.userName} - ${this.$t('dailyReport.reportCard.managerView')}`
        : this.$t('dailyReport.reportCard.title');
    },

    btnClass() {
      return this.computedReportCard.userName ? 'back-btn' : '';
    },
  },
  methods: {
    save() {
      this.reportCard.status = 'delivered';
      this.reportCard.userReference = this.$store.state.user.informations.reference;
      const tempArray = [];
      tempArray.push(this.reportCard);
      this.$services.dailyReport.saveReportCard(tempArray).then(() => {
        this.$router.push('/dailyReportCalendar');
        this.$miniToastr.success('success');
      });
    },
    back() {
      this.$router.back(-2);
      // this.$router.push('/dailyReport/managerView');
    },
  },
};
</script>

<style lang="scss" scoped>
.card-body {
  padding: 0.65rem !important;
}
.comment-section {
  h5 {
    font-family: "SF-Pro-Text";
    font-size: 22px;
    font-weight: 600;
    color: #212529;
  }
  p {
    font-size: 16px;
    color: #212529;
    font-family: "SF-Pro-Text";
  }
}
.calander-div {
  border-radius: 18px;
  box-shadow: 0 7px 40px 0 rgba(90, 97, 105, 0.1);
  background-color: #f6a91d;
  img {
    width: 50px;
    height: 50px;
    @media screen and (min-width: 320px) and (max-width: 1300px) {
      width: 30px;
      height: 30px;
    }
  }
}
.submission-div {
  border-radius: 18px;
  box-shadow: 0 7px 40px 0 rgba(90, 97, 105, 0.1);
  background-color: #17c671;
  img {
    width: 50px;
    height: 50px;
    @media screen and (min-width: 320px) and (max-width: 1300px) {
      width: 30px;
      height: 30px;
    }
  }
}
.clock-div {
  border-radius: 18px;
  box-shadow: 0 7px 40px 0 rgba(90, 97, 105, 0.1);
  background-color: #06aeea;
  img {
    width: 50px;
    height: 50px;
    @media screen and (min-width: 320px) and (max-width: 1300px) {
      width: 30px;
      height: 30px;
    }
  }
}
.duration {
  color: #212529;
  font-family: "SF-Pro-Text";
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.19;
  padding-top: 5px;
  letter-spacing: -0.19px;
}
.text {
  color: #4f78e2;
  object-fit: contain;
  opacity: 0.64;
  font-family: "SF-Pro-Text";
  padding: 10px;
  font-size: 15px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: -0.7px;
}
.comment {
  color: #212529;
  font-family: "SF-Pro-Text";
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.19;
}
.btn-back {
  background-color: #fff;
  color: #4f78e1;
  border-radius: 8px;
  padding: 10px 30px;
  border: 1px solid #4f78e1;
  i {
    position: relative;
    right: 5px;
  }
}
</style>
